import { Link } from 'react-router-dom';
import sections from '../Data/cards';

const Works = () => {
    return (
        <div className="px-[2rem]">
            {sections.map((section, sectionIndex) => (
                <div key={sectionIndex}>
                    {/* Section Title */}
                    <div className="mt-4 flex justify-center items-center">
                        <div className="flex flex-col items-left max-w-[30rem] w-full">
                            <p className="text-white font-bold text-[20px]">{section.title}</p>
                        </div>
                    </div>

                    {/* Cards for Section */}
                    <div className="px-[1rem] mt-[1rem] flex justify-center flex-wrap gap-4">
                        {section.cards.map((card) => (
                            <Link
                                key={card.id}
                                to={`/works/${card.id}`}
                                className="max-w-[15rem] overflow-hidden rounded-xl shadow-md duration-200 hover:scale-105 hover:shadow-xl"
                            >
                                <div className="aspect-[16/9] w-full relative">
                                    <img src={card.image} alt={card.title}
                                         className="absolute w-full h-full object-cover"/>
                                </div>
                                <div className="px-[1rem] py-[3px] justify-center items-center">
                                    <p className="font-bold text-center text-white">{card.title}</p>
                                    <p className="pt-[0.5rem] text-center text-white pb-[10px]">
                                        {card.description}
                                    </p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            ))}
            <div className="mt-4 flex justify-center items-center">
                <div className="p-3 bg-[#323234] rounded-lg max-w-[30rem] w-full">
                    <p className="text-white font-regular text-[20px] text-center">
                    This portfolio section is currently a work in progress, and not all of my projects are listed here yet. The displayed projects are available for viewing. If you'd like to see more of my work or learn more about my skills and experiences, please visit my LinkedIn profile.
                    </p>

                    <div className="flex justify-center mt-4">
                        <Link to={"https://www.linkedin.com/in/josh-kyle-arce-44b46832a"}>
                            <button type="button"
                                    className="text-white bg-pink-600 hover:bg-pink-800 font-bold rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center ">
                                LinkedIn
                                <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M1 5h12m0 0L9 1m4 4L9 9"/>
                                </svg>
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Works;
